import { WizardProvider } from '../../../components/wizard/useWizard';
import { Button, Card, Divider, Grid, Typography } from 'antd';
import { PreWorkProvider } from './usePreWorkWizard';
import { useAuth } from '../../../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/ui-components/Icon';
import { APPLICANT_HOME, PRE_WORK } from '../../../shared/Routes';
import { useApplicationId } from '../../../hooks/useApplicationId';
import RightArrowWhite from '../../../assets/images/arrow-right-white.svg';

const { useBreakpoint } = Grid;
const { Text } = Typography;

export const PreWorkContextPolicy = () => {
	const { t } = useTranslation();
	const { mySrcmProfile } = useAuth();
	const candidateName = mySrcmProfile?.name;
	const screens = useBreakpoint();
	const isMobile = !screens.sm;
	const { navigateWithApplicationId } = useApplicationId();
	return (
		<>
			<Card className="w-full md:w-[50%] mx-auto font-sans">
				<div className="flex justify-center w-full mx-0">
					<div
						className={`flex flex-col h-full min-h-0 p-[8px] ${
							isMobile ? 'w-full' : 'w-[95%]'
						}`}
					>
						<div className="flex flex-col h-full min-h-0">
							<Text className="flex-grow font-sans font-semibold text-lg text-secondary-black text-center">
								{t('instructions')}
							</Text>
							<Divider className="border border-solid border-gray-200" />
							<div className="flex flex-col mb-[8px]">
								<p>{t('dearCandidateName', { candidateName })}</p>
								<p>{t('thankYouForVolunteering')}</p>
							</div>
						</div>
					</div>
				</div>
				<div className={`flex justify-center w-full gap-4 mt-4 font-sans`}>
					<Button
						onClick={() => navigateWithApplicationId(APPLICANT_HOME)}
						className="font-bold text-sm"
					>
						{t('cancel')}
					</Button>
					<Button
						type="primary"
						onClick={() => navigateWithApplicationId(PRE_WORK)}
						className="font-bold text-sm"
					>
						{t('next')}
						<Icon src={RightArrowWhite} width={'w-5'} height={'h-5'} />
					</Button>
				</div>
			</Card>
		</>
	);
};

export const PreWorkContextWizardContainer = () => {
	return (
		<PreWorkProvider>
			<WizardProvider>
				<PreWorkContextPolicy />
			</WizardProvider>
		</PreWorkProvider>
	);
};
